"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindow = void 0;
// This only done for the purpose of testing
var getWindow = exports.getWindow = function getWindow() {
  return window;
};